import React from 'react'

import SearchIcon from 'assets/icons/search-icon'
import ClearIcon from 'assets/icons/clear-icon'
import CheckIcon from 'assets/icons/check-icon'

import {
  ClearSearchDropdownIcon,
  SearchDropdownContainer, SearchDropDownDivider,
  SearchDropdownIcon,
  SearchDropdownIconWrapper, SearchSelectContainer,
  StyledSelect
} from './style'
import Button from '../Button'
import { FormattedMessage } from 'react-intl'

const SearchDropdown = ({
  value,
  onChange,
  options,
  label,
  field,
  error,
  placeholder,
  height = '48px',
  menuPlacement,
  marginTop = '8px',
  marginBottom = '32px',
  indicatorSize = 'none',
  dataTest,
  disabled,
  closeMenuOnSelect = true,
  infoTooltip,
  zIndex,
  menuWidth = '100%',
  buttonName = 'Button name',
  buttonOnClick,
  buttonDisabled,
  inputValue,
  onInputChange,
  hyper,
  buttonIsPresent = true,
  iconTopPosition = '-32px',
  inputMargin= '8px 0 8px 16px'
}) => {
  function handleClearInput() {
    onChange(null)
  }

  function handleOnCLickButton() {
    buttonOnClick(value)
    onChange(null)
  }

  return (
    <>
      <SearchDropdownContainer>
        <SearchSelectContainer buttonIsPresent={buttonIsPresent}>
          <StyledSelect
            value={value}
            onChange={onChange}
            options={options}
            label={label}
            field={field}
            error={error}
            placeholder={placeholder}
            height={height}
            menuPlacement={menuPlacement}
            marginTop={marginTop}
            marginBottom={marginBottom}
            indicatorSize={indicatorSize}
            dataTest={dataTest}
            disabled={disabled}
            closeMenuOnSelect={closeMenuOnSelect}
            infoTooltip={infoTooltip}
            zIndex={zIndex}
            paddingLeft={buttonIsPresent ? '48px' : '24px'}
            isSearchable={true}
            menuWidth={menuWidth}
            inputValue={inputValue}
            onInputChange={onInputChange}
            searchDropdown={true}
            hyper={hyper}
            inputMargin={inputMargin}
          />
        </SearchSelectContainer>
        {buttonIsPresent && (
          <Button
            height='40px'
            marginTop='0'
            onClick={handleOnCLickButton}
            isDisabled={buttonDisabled}
            withIcon={true}
            type={buttonDisabled ? 'disabledPrimary' : 'primary'}
          >
            <CheckIcon />
            <FormattedMessage id={buttonName} />
          </Button>
        )}
      </SearchDropdownContainer>
      <SearchDropdownIconWrapper>
        <SearchDropdownIcon buttonIsPresent={buttonIsPresent} iconTopPosition={iconTopPosition}>
          <SearchIcon />
        </SearchDropdownIcon>
        {buttonIsPresent && <SearchDropDownDivider iconTopPosition={iconTopPosition} />}
        {value && buttonIsPresent && (
          <ClearSearchDropdownIcon iconTopPosition={iconTopPosition} onClick={handleClearInput}>
            <ClearIcon />
          </ClearSearchDropdownIcon>
        )}
      </SearchDropdownIconWrapper>
    </>
  )
}

export default SearchDropdown
